import React, { useState, useEffect } from 'react'
import { useNavigate } from "react-router-dom";
import Api from "../../api";
import { FaBuilding, FaCalendarAlt, FaClock, FaUser, FaBook, FaCheckCircle, FaTimesCircle, FaEye, FaEdit, FaCheck } from "react-icons/fa";
import { toast } from "react-toastify";
import { motion, AnimatePresence } from 'framer-motion';
import { useData } from '../../context/DataContext';
import dayjs from 'dayjs';
import 'dayjs/locale/id';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
// Import PrimeReact CSS
import 'primereact/resources/themes/lara-light-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import { SipCalendar, SipDropdown, SipSearch } from "../../components/form/SipControls";

// Set locale ke Indonesia
dayjs.locale('id');

// Custom CSS untuk toast konfirmasi
const toastConfirmStyle = `
  .custom-toast-confirm {
    background: white !important;
    border: 1px solid #e5e7eb !important;
    border-radius: 12px !important;
    box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
    padding: 16px !important;
    min-width: 400px !important;
  }
  
  .custom-toast-confirm .Toastify__toast-body {
    padding: 0 !important;
    margin: 0 !important;
  }
`;

// Inject CSS
if (typeof document !== 'undefined') {
  const style = document.createElement('style');
  style.textContent = toastConfirmStyle;
  document.head.appendChild(style);
}

function PenggunaanLab() {
  const navigate = useNavigate();
  const [searchTerm, setSearchTerm] = useState('');
  const [filterStatus, setFilterStatus] = useState('all');
  const [filterLab, setFilterLab] = useState('all');
  const [selectedDate, setSelectedDate] = useState('');
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const{lab,getLabs}=useData()

  // Sample data - replace with actual API call
  const getData=async()=>{
    try {
      setLoading(true);
      const response = await Api.get('/mon/jadwal-lab');
      setRows(response.data.data);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  }

  useEffect(() => {
    getData()
    getLabs()
  }, []);

  const handleBack = () => {
    navigate(-1);
  };

  // Fungsi untuk mengubah status
  const handleUpdateStatus = async (id, newStatus) => {
    try {
      setLoading(true);
      console.log(newStatus)
      await Api.put(`/mon/jadwal-lab/${id}`, {
        status: newStatus
      });
      
      toast.success("status berhasil di ubah")
      getData()
    } catch (error) {
      console.error('Error updating status:', error);
      toast.error('Terjadi kesalahan saat mengubah status');
    } finally {
      setLoading(false);
    }
  };

  // Fungsi untuk konfirmasi perubahan status menggunakan toast
  const confirmStatusChange = (item, newStatus) => {
    const statusText = newStatus === '1' ? 'Selesai' : 'Dijadwalkan';
    const currentStatusText = item.status === '1' ? 'Selesai' : 'Dijadwalkan';
    
    // Custom toast dengan tombol konfirmasi
    const toastId = toast(
      ({ closeToast }) => (
        <div className="flex flex-col gap-3">
          <div className="text-sm font-medium text-gray-900">
            Konfirmasi Perubahan Status
          </div>
          <div className="text-sm text-gray-600">
            Apakah Anda yakin ingin mengubah status dari "{currentStatusText}" menjadi "{statusText}"?
          </div>
          <div className="flex gap-2 justify-end">
            <button
              onClick={() => {
                closeToast();
              }}
              className="px-3 py-1.5 text-sm font-medium text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg transition-colors duration-200"
            >
              Batal
            </button>
            <button
              onClick={() => {
                handleUpdateStatus(item.id, newStatus);
                closeToast();
              }}
              className="px-3 py-1.5 text-sm font-medium text-white bg-primary hover:bg-primary-dark rounded-lg transition-colors duration-200"
            >
              Ya, Ubah
            </button>
          </div>
        </div>
      ),
      {
        position: "top-center",
        autoClose: false,
        hideProgressBar: true,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: false,
        closeButton: false,
        className: "custom-toast-confirm",
      }
    );
  };

  const getStatusColor = (status) => {
    switch (status) {
      case '1':
        return 'bg-green-100 text-green-800 border-green-200';
      case '0':
        return 'bg-yellow-100 text-yellow-800 border-yellow-200';
      default:
        return 'bg-gray-100 text-gray-800 border-gray-200';
    }
  };

  const getStatusIcon = (status) => {
    switch (status) {
      case '1':
        return <FaCheckCircle className="w-4 h-4" />;
      case '0':
        return <FaCalendarAlt className="w-4 h-4" />;
      default:
        return <FaTimesCircle className="w-4 h-4" />;
    }
  };

  const filteredData = rows.filter(item => {
    const matchesSearch = item.nama_lab?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.pj?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.mapel?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                         item.kelas?.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesStatus = filterStatus === 'all' || item.status === filterStatus;
    const matchesLab = filterLab === 'all' || item.nama_lab === filterLab;
    
    // Filter tanggal yang lebih robust
    let matchesDate = true;
    if (selectedDate && item.tgl) {
      try {
        // Normalisasi tanggal dari item
        const itemDate = new Date(item.tgl);
        const selectedDateObj = new Date(selectedDate);
        
        // Bandingkan hanya tanggal (tanpa waktu)
        const itemDateString = itemDate.toISOString().split('T')[0];
        const selectedDateString = selectedDateObj.toISOString().split('T')[0];
        
        matchesDate = itemDateString === selectedDateString;
      } catch (error) {
        // Fallback: bandingkan string langsung
        matchesDate = item.tgl === selectedDate || 
                     item.tgl.includes(selectedDate) ||
                     selectedDate.includes(item.tgl);
      }
    }
    
    return matchesSearch && matchesStatus && matchesLab && matchesDate;
  });

  return (
    <div className="space-y-6">
      <div className="max-w-7xl mx-auto space-y-6">
        {/* ==================== HEADER SECTION ==================== */}
        <motion.div 
          className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          <div className="bg-primary px-6 py-8 md:px-8">
            <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
              {/* Judul Halaman */}
              <div className="text-white">
                <div className="flex items-center gap-3 mb-2">
                  <div className="p-3 bg-white/20 rounded-xl backdrop-blur-sm">
                    <FaBuilding className="text-xl" />
                  </div>
                  <h1 className="text-2xl md:text-3xl font-bold">
                    Penggunaan Laboratorium
                  </h1>
                </div>
                <p className="text-white/80 text-sm md:text-base">
                  Pantau dan kelola peminjaman dan penggunaan laboratorium
                </p>
              </div>

              {/* Tombol Kembali */}
              <button
                onClick={handleBack}
                className="flex items-center gap-2 bg-white/10 backdrop-blur-sm text-white border border-white/20 px-6 py-3 rounded-xl hover:bg-white/20 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5"
              >
                <svg
                  className="w-5 h-5"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 19l-7-7m0 0l7-7m-7 7h18"
                  />
                </svg>
                <span className="font-medium">Kembali</span>
              </button>
            </div>
          </div>
        </motion.div>

        {/* ==================== SEARCH AND FILTER SECTION ==================== */}
        <motion.div
          className="bg-white rounded-2xl shadow-lg border border-gray-100 p-6"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.1 }}
        >
          <div className="mb-6 flex flex-col gap-4 xl:flex-row">
            {/* Search Bar */}
            <div className="min-w-0 w-full flex-1">
              <SipSearch
                placeholder="Cari berdasarkan lab, guru, mata pelajaran, atau kelas..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>

            {/* Filter Controls */}
            <div className="grid w-full grid-cols-1 gap-3 sm:grid-cols-2 xl:flex xl:w-auto xl:flex-wrap">
              <div className="min-w-0 sm:col-span-2 xl:w-56">
                <SipCalendar
                  value={selectedDate}
                  onChange={(e) => setSelectedDate(e.target.value)}
                  placeholder="Tanggal penggunaan"
                />
              </div>
              <SipDropdown
                value={filterStatus}
                onChange={(e) => setFilterStatus(e.target.value)}
                className="xl:w-44"
                options={[
                  { label: "Semua Status", value: "all" },
                  { label: "Dijadwalkan", value: "0" },
                  { label: "Selesai", value: "1" },
                ]}
              />
              <SipDropdown
                value={filterLab}
                onChange={(e) => setFilterLab(e.target.value)}
                className="xl:w-48"
                options={[
                  { label: "Semua Lab", value: "all" },
                  ...(lab || []).map((labItem) => ({
                    label: labItem.nama_lab,
                    value: labItem.nama_lab,
                  })),
                ]}
              />
            </div>
          </div>

          {/* Quick Stats */}
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            <div className="bg-primary/5 p-4 rounded-xl border border-secondary">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-primary text-white rounded-lg">
                  <FaCalendarAlt className="w-4 h-4" />
                </div>
                <div>
                  <p className="text-sm text-primary font-medium">Total Jadwal</p>
                  <p className="text-xl font-bold text-slate-800">{filteredData.length}</p>
                </div>
              </div>
            </div>

            <div className="bg-accent/5 p-4 rounded-xl border border-secondary">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-green-500 text-white rounded-lg">
                  <FaCheckCircle className="w-4 h-4" />
                </div>
                <div>
                  <p className="text-sm text-green-600 font-medium">Selesai</p>
                  <p className="text-xl font-bold text-green-800">
                    {filteredData.filter(item => item.status === '1').length}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-warning/5 p-4 rounded-xl border border-secondary">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-yellow-500 text-white rounded-lg">
                  <FaClock className="w-4 h-4" />
                </div>
                <div>
                  <p className="text-sm text-yellow-600 font-medium">Berlangsung</p>
                  <p className="text-xl font-bold text-yellow-800">
                    {rows.filter(item => {
                      const now = new Date();
                      const itemDate = new Date(item.tgl);
                      const startTime = new Date(`${item.tgl} ${item.jam_mulai}`);
                      const endTime = new Date(`${item.tgl} ${item.jam_selesai}`);
                      return item.status === '0' && now >= startTime && now <= endTime;
                    }).length}
                  </p>
                </div>
              </div>
            </div>

            <div className="bg-primary/5 p-4 rounded-xl border border-secondary">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-purple-500 text-white rounded-lg">
                  <FaCalendarAlt className="w-4 h-4" />
                </div>
                <div>
                  <p className="text-sm text-purple-600 font-medium">Dijadwalkan</p>
                  <p className="text-xl font-bold text-purple-800">
                    {filteredData.filter(item => item.status === '0').length}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* ==================== TABLE SECTION ==================== */}
        <motion.div
          className="bg-white rounded-2xl shadow-lg border border-gray-100 overflow-hidden"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          {/* PrimeReact DataTable */}
          <div className="p-6">
            <DataTable
              value={filteredData}
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Menampilkan {first} sampai {last} dari {totalRecords} data"
              emptyMessage="Tidak ada data jadwal lab yang tersedia"
              loading={loading}
              stripedRows
              showGridlines
              responsiveLayout="scroll"
              className="p-datatable-sm"
            >
              {/* Template untuk tanggal */}
              <Column 
                field="tgl" 
                header="Tanggal" 
                body={(rowData) => (
                  <div className="flex items-center gap-2">
                    <FaCalendarAlt className="text-gray-400 text-sm" />
                    <span className="text-sm font-medium text-gray-900">
                      {dayjs(rowData.tgl).format('DD MMMM YYYY')}
                    </span>
                  </div>
                )}
                style={{ minWidth: '150px' }}
                sortable
              />

              {/* Template untuk nama lab */}
              <Column 
                field="nama_lab" 
                header="Nama Lab" 
                body={(rowData) => (
                  <div className="flex items-center gap-3">
                    <div className="p-2 bg-primary/10 rounded-lg">
                      <FaBuilding className="w-4 h-4 text-primary" />
                    </div>
                    <span className="text-sm font-medium text-gray-900">{rowData.nama_lab}</span>
                  </div>
                )}
                style={{ minWidth: '180px' }}
                sortable
              />

              {/* Template untuk waktu */}
              <Column 
                field="jam_mulai" 
                header="Waktu" 
                body={(rowData) => (
                  <div className="text-sm text-gray-900">
                    <div className="font-medium">{rowData.jam_mulai} - {rowData.jam_selesai}</div>
                    <div className="text-xs text-gray-500">
                      {Math.round((new Date(`2024-01-01 ${rowData.jam_selesai}`) - new Date(`2024-01-01 ${rowData.jam_mulai}`)) / (1000 * 60))} menit
                    </div>
                  </div>
                )}
                style={{ minWidth: '150px' }}
                sortable
              />

              {/* Template untuk mata pelajaran */}
              <Column 
                field="mapel" 
                header="Mata Pelajaran" 
                body={(rowData) => (
                  <div className="flex items-center gap-2">
                    <FaBook className="text-gray-400 text-sm" />
                    <span className="text-sm font-medium text-gray-900">{rowData.mapel}</span>
                  </div>
                )}
                style={{ minWidth: '180px' }}
                sortable
              />

              {/* Template untuk guru dan kelas */}
              <Column 
                field="pj" 
                header="Guru & Kelas" 
                body={(rowData) => (
                  <div className="text-sm">
                    <div className="font-medium text-gray-900">{rowData.pj}</div>
                    <div className="text-gray-500">{rowData.kelas}</div>
                  </div>
                )}
                style={{ minWidth: '200px' }}
                sortable
              />

              {/* Template untuk status */}
              <Column 
                field="status" 
                header="Status" 
                body={(rowData) => (
                  <span className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm font-medium border ${getStatusColor(rowData.status)}`}>
                    {getStatusIcon(rowData.status)}
                    {rowData.status === '1' ? 'Selesai' : 'Terjadwal'}
                  </span>
                )}
                style={{ minWidth: '130px' }}
                sortable
              />

              {/* Template untuk aksi */}
              <Column 
                field="id" 
                header="Aksi" 
                body={(rowData) => (
                  <div className="flex items-center gap-2">
                    {rowData.status === '0' ? (
                      <button 
                        onClick={() => confirmStatusChange(rowData, '1')}
                        className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-green-600 hover:text-green-700 bg-green-50 hover:bg-green-100 rounded-lg transition-all duration-200"
                        title="Tandai Selesai"
                        disabled={loading}
                      >
                        <FaCheck className="w-4 h-4" />
                        Selesai
                      </button>
                    ) : (
                      <button 
                        onClick={() => confirmStatusChange(rowData, '0')}
                        className="flex items-center gap-2 px-3 py-2 text-sm font-medium text-yellow-600 hover:text-yellow-700 bg-yellow-50 hover:bg-yellow-100 rounded-lg transition-all duration-200"
                        title="Ubah ke Dijadwalkan"
                        disabled={loading}
                      >
                        <FaEdit className="w-4 h-4" />
                        Jadwalkan
                      </button>
                    )}
                  </div>
                )}
                style={{ minWidth: '120px', textAlign: 'center' }}
                sortable={false}
              />
            </DataTable>
          </div>




        </motion.div>
      </div>
    </div>
  )
}

export default PenggunaanLab